import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import RightArrow from "../../svg/RightArrow";
import DashboardLayer from "../../../images/dashboard-layer.svg";

function Recommendations({ image, title, subTitle, links, flag }) {
  const { t } = useContext(LanguageContext);

  return (
    <div
      style={{
        height: "100%",
        position: "relative",
        borderRadius: "10px",
        overflow: "hidden", // make sure this is set
        zIndex: 1, // ensure it's correctly layered
      }}
    >
      <div
        className={`h-100`}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `linear-gradient(to bottom, rgba(30, 32, 34,0.1), rgba(30, 32, 34,0.5)), url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(1.55px)",
          zIndex: 0,
          transform: "scale(1.05)",
        }}
      />

      <div
        className={`h-100`}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${DashboardLayer})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: 1,
          opacity: 0.35,
        }}
      />

      <div
        className="h-100 p-4 d-flex flex-column justify-content-between"
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          width: "100%",
          color: "#fff",
        }}
      >
        <div>
          <span className="recommendation-badge">{t("Recommendations")}</span>
          <div>
            <h2 className="title-announcement">{title}</h2>
            <p className="excerpt-announcement">{subTitle}</p>
          </div>
        </div>
        <p
          className={`${
            flag === true ? "see-recomendation-text" : "see-offer-text"
          } cursor-pointer d-flex align-items-center`}
        >
          {links} <RightArrow />
        </p>
      </div>
    </div>
  );
}

export default Recommendations;
